const aliases = {
 catalog:'קטלוג דגם דגמים פריט פריטים',developments:'פיתוח פיתוחים מעצב עיצובים',
 orders:'הזמנה הזמנות משלוחים ספקים סקירה',qc:'קיוסי איכות בדיקות',sales:'מכר מכירות',
 projects:'פרויקט פרויקטים',lens:'עדשה עדשות',acetate:'אצטט חומר מסגרת חומרים',files:'קובץ קבצים מסמכים',collection:'קולקציה אוסף עונה',
};
export function matchHomeDestinations(destinations, text, pins=[]) {
 const q=text.trim().toLowerCase();
 const ordered=q?destinations:[...pins,...destinations.filter(d=>!pins.some(p=>p.id===d.id))];
 return ordered.filter(d=>!q||`${d.label} ${d.description||''} ${d.portal} ${aliases[d.portal]||''}`.toLowerCase().includes(q))
  .map(d=>d.locked?{id:d.id,label:d.label,locked:true,portal:d.portal}:d);
}
export function homeRecordResult(record,kind) {
 const x=record.data||record;
 const labels={item:record.sku||record.model,dev:x.dev_number,designer:record.name,brand:record.name,lens:record.lens_no,ltd:record.code,order:record.pi,acetate:record.acetate_no};
 const detail={item:record.model,dev:x.designer,lens:record.name,ltd:record.name,order:record.item_no||record.model,acetate:record.colour_name};
 return {id:`${kind}:${record.source||''}:${record.id||labels[kind]}`,label:labels[kind]||record.id,description:[kind==='order'?`${record.source==='desk'?'Order Desk':'Orders Book'}`:kind,detail[kind]].filter(Boolean).join(' · '),record:{...record,k:kind},icon:({item:'glasses',dev:'pen',lens:'lens',ltd:'lens',order:'orders',acetate:'layers'})[kind]||'arrow'};
}
